import { Select as SelectDS } from "@moodstudios/farmacenter-design";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps {
  label?: string;
  value: string | null;
  options: SelectOption[];
  onChange: (value: string | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Un desplegable del sistema de diseño (Radix, no el `<select>` nativo, cuya
 * lista abierta la pinta el SO y se ve fuera de estilo). Envuelve el `Select` del
 * paquete con la etiqueta del backoffice. Un valor nulo es "sin selección" y
 * muestra el placeholder.
 */
export function Select({
  label,
  value,
  options,
  onChange,
  placeholder = "Selecciona…",
  disabled,
  className,
}: SelectProps) {
  return (
    <div className={`flex flex-col gap-1 ${className ?? ""}`}>
      {label ? (
        <span className="font-data text-2xs font-semibold uppercase tracking-[0.14em] text-text-muted">
          {label}
        </span>
      ) : null}
      <SelectDS
        items={options}
        placeholder={placeholder}
        onValueChange={(v) => onChange(v)}
        {...(value !== null ? { value } : {})}
        {...(disabled || options.length === 0 ? { disabled: true } : {})}
      />
    </div>
  );
}
